// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__dtdLb","animloader":"loader_animloader__t2Id3"};